module.exports = __webpack_public_path__ + "static/media/congrats_icon.7a05ebac.png";